module.exports = __webpack_public_path__ + "static/4cc23c643ab4f4cc3ff02a7362716c82d3ed00013ac790688cab1ac2aa7d338e-32cfa65e3ef6ca7bd06407319ab87522.png";